module.exports = __webpack_public_path__ + "static/img/shenglisige_icon.9d88e6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/shenglisige_icon.png
// module id = 0JtP
// module chunks = 1